// extracted by css-extract-rspack-plugin
export default {"root":"Carousel_root__8Qadw","track_vertical":"Carousel_track_vertical__8ADNI","slide":"Carousel_slide__0xTqK"};